export const errorAlertMaxWidth: number = 500;